var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAaplballerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 440.8,
    cy: 440.4,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.8,465.2H89.2l69.5-201.4h54.9L283,465.2h-45.6l-50.4-155.4h-1.6L134.8,465.2z M132,386.1h107.8v33.2 H132V386.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.9,465.2h-45.6l69.5-201.4h54.9l69.4,201.4h-45.6L384,309.9h-1.6L331.9,465.2z M329.1,386.1h107.8v33.2 H329.1V386.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.3,465.2V263.9h79.5c15.3,0,28.3,2.9,39,8.7c10.8,5.8,19,13.8,24.6,24.1c5.7,10.3,8.5,22.1,8.5,35.5 c0,13.4-2.9,25.2-8.7,35.4c-5.8,10.2-14.1,18.2-25,23.9c-10.9,5.7-24.1,8.6-39.6,8.6h-50.6v-34.1h43.8c8.2,0,15-1.4,20.3-4.3 c5.3-2.9,9.3-6.8,12-11.9c2.7-5.1,4-10.9,4-17.6c0-6.7-1.3-12.5-4-17.6c-2.7-5-6.7-8.9-12-11.7c-5.4-2.8-12.2-4.2-20.5-4.2h-28.7 v166.6H494.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.7,465.2V263.9h42.6v166.3h86.3v35.1H663.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.9,703.8c-4,0-7.4,3.3-7.4,7.4v42c0,4,3.3,7.4,7.4,7.4c4,0,7.4-3.3,7.4-7.4v-42 C448.3,707.1,445,703.8,440.9,703.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.5,669.8c-2.9-2.9-7.5-2.9-10.4,0c-2.9,2.9-2.9,7.5,0,10.4l29.7,29.7c2.9,2.9,7.5,2.9,10.4,0 c2.9-2.9,2.9-7.5,0-10.4L533.5,669.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.7,587.6c0-4-3.3-7.4-7.4-7.4h-42c-4,0-7.4,3.3-7.4,7.4c0,4,3.3,7.4,7.4,7.4h42 C321.4,595,324.7,591.7,324.7,587.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.4,580.3h-42c-4,0-7.4,3.3-7.4,7.4c0,4,3.3,7.4,7.4,7.4h42c4,0,7.4-3.3,7.4-7.4 C613.8,583.6,610.5,580.3,606.4,580.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.4,669.8l-29.7,29.7c-2.9,2.9-2.9,7.5,0,10.4c2.9,2.9,7.5,2.9,10.4,0l29.7-29.7c2.9-2.9,2.9-7.5,0-10.4 C355.9,666.9,351.2,666.9,348.4,669.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493,585.1c-4.3-3-9.1-5.5-14.5-7.3c-5.4-1.8-11-3.4-16.7-4.7c-4.6-1.1-9.1-2-13.5-3v-30.7 c3.3,0.7,6.3,1.7,9.1,3.1c5.2,2.6,8,7.8,8.6,15.3h37.3c-0.7-8.9-3-16.2-6.8-22c-3.8-5.8-8.5-10.5-14.3-14 c-5.7-3.5-12.2-6-19.5-7.5c-4.7-1-9.6-1.5-14.5-1.8v-17h-14.7v16.9c-5.4,0.3-10.8,0.8-16,1.8c-7.4,1.4-14,3.8-19.9,7.2 c-5.9,3.4-10.6,8.1-14.2,14.1c-3.6,6-5.4,13.5-5.4,22.5c0,6.3,1.3,11.6,3.9,15.9c2.6,4.4,6,7.9,10.2,10.8 c4.3,2.9,9.1,5.1,14.5,6.9c5.4,1.8,11,3.2,16.7,4.6c3.6,0.8,7,1.5,10.2,2.2v37.2c-0.9-0.2-1.7-0.3-2.6-0.5 c-3.6-0.9-6.8-2.3-9.5-4.3c-2.8-1.9-5-4.4-6.8-7.5c-1.8-3-2.6-6.7-2.6-10.9h-37.3c0.4,9.4,2.5,17.3,6.5,23.8 c4,6.5,9,11.7,15.2,15.6c6.2,4,13.2,6.8,21.1,8.4c5.2,1.1,10.6,1.7,16,2.1v17h14.7v-16.9c5.9-0.3,11.8-0.9,17.5-2.2 c7.8-1.6,14.8-4.4,20.9-8.3c6.1-3.9,11-9,14.8-15.3c3.8-6.4,5.7-14.3,5.7-23.6c0-6.6-1.3-12.2-3.9-16.7 C500.7,591.9,497.3,588.2,493,585.1z M431.2,565.8c-4.1-1.4-7.5-3.2-10.1-5.4c-2.6-2.2-3.9-5.1-3.9-8.6c0-2.9,0.7-5.3,2.2-7 c1.5-1.8,3.3-3.1,5.4-4c2.1-0.9,4.5-1.5,7-1.8c0.6-0.1,1.1-0.1,1.6-0.1v27.6C432.8,566.2,432,566,431.2,565.8z M465.4,627.2 c-1.7,2.3-3.7,4.1-6.2,5.5c-2.5,1.4-5.2,2.4-8.3,3.1c-0.9,0.2-1.7,0.3-2.6,0.4v-33.8c2.9,0.9,5.6,1.8,7.8,2.8 c3.8,1.7,6.7,3.5,8.7,5.7c2,2.1,3,4.7,3,7.6C467.9,621.9,467.1,624.8,465.4,627.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaplballerIcon);
export default __webpack_public_path__ + "static/media/aaplballer_icon.42520d92bb91074a772257d0966cb190.svg";
export { ForwardRef as ReactComponent };